import { useMemo } from 'react';
import { Table, useQueryState, formatDate, SelectItemProps } from '@ui/src';
import { useAppSelector } from '@store';
import Card from '../partial/card/card';
import { PspAccountLogs } from '../../hoc/bank-and-psp/types';
import {
  accountChangeLogSchema,
  accountChangeLogColumns,
} from '../../hoc/bank-and-psp/variables/account-change-log';
import { getPspAccountLogsType } from '../../hoc/bank-and-psp/helpers/get-enums-names';

import cn from './info.module.css';
import { ChangeLogTypes } from './types';

const formatLogsList = (
  list: PspAccountLogs[],
  currencies: SelectItemProps[],
): PspAccountLogs[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };

    const { typeName, operationValue } = getPspAccountLogsType(
      result.type,
      result.value,
      currencies,
    );

    const render: Record<string, React.JSX.Element> = {
      type: <div>{typeName}</div>,
      createdAt: <div>{formatDate(result.createdAt, true)}</div>,
      value: <div className={cn.operationValue}>{operationValue}</div>,
    };

    result.render = render;

    return result;
  });

  return nextList;
};

const ChangeLog = ({ changeLog, isLoading, logsErrors }: ChangeLogTypes) => {
  const { sort } = useQueryState(accountChangeLogSchema);

  const { currencies } = useAppSelector(
    (state) => state.configurationDictionaries,
  );

  const formattedData = useMemo(() => {
    const data = formatLogsList(
      changeLog as PspAccountLogs[],
      currencies as SelectItemProps[],
    );

    return data;
  }, [changeLog, sort, currencies]);

  return (
    <Card className={cn.documentsCard} isLoading={isLoading} title="Change log">
      <Table
        columns={accountChangeLogColumns}
        data={formattedData || []}
        error={logsErrors}
        onSort={() => {}}
        filters={{}}
        sort={sort}
        columnsLabels={{}}
        onFilterChange={() => {}}
        tableBodyClassName={!changeLog?.length ? cn.emptyInternalTable : ''}
      />
    </Card>
  );
};

export default ChangeLog;
